import { BlogSection } from '../../../../mocks/blog-posts';

interface Props {
  sections: BlogSection[];
}

export default function ArticleContent({ sections }: Props) {
  return (
    <div className="prose-custom space-y-6">
      {sections.map((section, i) => {
        switch (section.type) {
          case 'intro':
            return (
              <p key={i} className="text-base text-gray-700 leading-relaxed font-medium border-l-4 border-violet-400 pl-5 py-1 bg-violet-50/40 rounded-r-xl">
                {section.content}
              </p>
            );

          case 'h2':
            return (
              <div key={i} className="pt-4">
                <h2 className="text-xl font-black text-gray-900 mb-3 flex items-center gap-2">
                  <span className="w-1.5 h-6 rounded-full bg-gradient-to-b from-violet-500 to-fuchsia-500 flex-shrink-0 inline-block"></span>
                  {section.heading}
                </h2>
                {section.content && (
                  <p className="text-sm text-gray-700 leading-relaxed">{section.content}</p>
                )}
              </div>
            );

          case 'h3':
            return (
              <div key={i} className="pt-2">
                <h3 className="text-base font-black text-gray-800 mb-2">{section.heading}</h3>
                {section.content && (
                  <p className="text-sm text-gray-700 leading-relaxed">{section.content}</p>
                )}
              </div>
            );

          case 'paragraph':
            return (
              <p key={i} className="text-sm text-gray-700 leading-relaxed">
                {section.content}
              </p>
            );

          case 'bullets':
            return (
              <ul key={i} className="space-y-2.5 my-2">
                {section.items?.map((item, ii) => (
                  <li key={ii} className="flex items-start gap-3">
                    <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center rounded-full bg-gradient-to-br from-violet-500 to-fuchsia-500 mt-0.5">
                      <i className="ri-check-line text-white text-xs"></i>
                    </span>
                    <span className="text-sm text-gray-700 leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            );

          case 'numbered':
            return (
              <ol key={i} className="space-y-3 my-2">
                {section.items?.map((item, ii) => (
                  <li key={ii} className="flex items-start gap-3">
                    <span className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-gradient-to-br from-violet-500 to-fuchsia-500 text-white text-xs font-black mt-0.5">
                      {ii + 1}
                    </span>
                    <span className="text-sm text-gray-700 leading-relaxed">{item}</span>
                  </li>
                ))}
              </ol>
            );

          case 'callout':
            return (
              <div key={i} className="bg-amber-50 border border-amber-200 rounded-2xl p-5 flex items-start gap-3">
                <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-xl bg-amber-400">
                  <i className="ri-lightbulb-flash-line text-white text-sm"></i>
                </div>
                <div>
                  <p className="text-xs font-bold text-amber-700 uppercase tracking-wider mb-1">Key Insight</p>
                  <p className="text-sm text-amber-900 leading-relaxed">{section.content}</p>
                </div>
              </div>
            );

          case 'tip':
            return (
              <div key={i} className="bg-emerald-50 border border-emerald-200 rounded-2xl p-5 flex items-start gap-3">
                <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-xl bg-emerald-500">
                  <i className="ri-thumb-up-line text-white text-sm"></i>
                </div>
                <div>
                  <p className="text-xs font-bold text-emerald-700 uppercase tracking-wider mb-1">Pro Tip</p>
                  <p className="text-sm text-emerald-900 leading-relaxed">{section.content}</p>
                </div>
              </div>
            );

          default:
            return null;
        }
      })}
    </div>
  );
}
